import { makeAutoObservable } from "mobx";
import ISnackbar from "../types/ISnackbar";

export class Snackbar implements ISnackbar {
  id: number;
  message: string;
  type: "primary" | "success" | "warning" | "danger" | "default";
  children?: any;
  timeoutInMs?: number | undefined;

  constructor(snackbar: ISnackbar) {
    makeAutoObservable(this);
    this.id = snackbar.id;
    this.message = snackbar.message;
    this.type = snackbar.type;
    this.children = snackbar.children;
    this.timeoutInMs = snackbar.timeoutInMs;
  }

  get asJson() {
    const snackbar: ISnackbar = {
      id: this.id,
      message: this.message,
      type: this.type,
      children: this.children,
      timeoutInMs: this.timeoutInMs,
    };
    return snackbar;
  }
}
